import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=29333c4d&scoped=true&"
import script from "./addProduct.vue?vue&type=script&lang=js&"
export * from "./addProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29333c4d",
  null
  
)

export default component.exports